export default {

    DateFormat(now) {
        let year = "" + now.getFullYear();
        let month = "" + (now.getMonth() + 1);
        if (month.length == 1) {
            month = "0" + month;
        }
        let day = "" + now.getDate();
        if (day.length == 1) {
            day = "0" + day;
        }
        let hour = "" + now.getHours();
        if (hour.length == 1) {
            hour = "0" + hour;
        }
        let minute = "" + now.getMinutes();
        if (minute.length == 1) {
            minute = "0" + minute;
        }
        let second = "" + now.getSeconds();
        if (second.length == 1) {
            second = "0" + second;
        }

        return day + "/" + month + "/" + year + " " + hour + ":" + minute + ":" + second;
    },

    getErrorMsg(err) {
        return (err.response && err.response.data ? (err.response.data.message || err.response.data) : err.message)
    },

    // ---- Formattazione numeri (locale italiano) ----
    formatEuro(v) {
        return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(v || 0)
    },

    // Es. 227.905.243 -> "227,9 Mln €" (assi dei grafici)
    formatEuroCompatto(v) {
        return new Intl.NumberFormat('it-IT', { notation: 'compact', maximumFractionDigits: 1 }).format(v || 0) + ' €'
    },

    formatNumero(v) {
        // useGrouping "always": in it-IT i numeri a 4 cifre altrimenti restano senza punto (5526).
        return new Intl.NumberFormat('it-IT', { maximumFractionDigits: 0, useGrouping: 'always' }).format(v || 0)
    },

    formatPerc(v, decimali = 1) {
        return new Intl.NumberFormat('it-IT', { minimumFractionDigits: decimali, maximumFractionDigits: decimali }).format(v || 0) + '%'
    },

    // Date -> "yyyy-MM-dd" in ora locale (formato dei v-text-field type="date" e dei parametri API)
    dataIso(d) {
        const mm = ("0" + (d.getMonth() + 1)).slice(-2);
        const dd = ("0" + d.getDate()).slice(-2);
        return d.getFullYear() + "-" + mm + "-" + dd;
    },

    nomeMese(m) {
        return ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"][m - 1];
    },

}
